<template>
  <div>
    <el-dropdown @command="handleCommand">
      <el-button type="primary" class="btn" size="small">
        Edit
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="content" v-if="canModifyContent">Content</el-dropdown-item>
        <el-dropdown-item command="date" v-if="canModifyDate">Date</el-dropdown-item>
        <el-dropdown-item command="address" v-if="canModifyAddress">Address</el-dropdown-item>
        <el-dropdown-item command="driver" v-if="canModifyDriver">Driver</el-dropdown-item>
        <el-dropdown-item command="history">See History</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <OperationHistory :dialogVisible="historyShow" :data="historyData" @closed="historyShow=false" />
    <DialogDate :dialogVisible="dateShow" @closed="dateShow=false" />
    <DialogAddress :dialogVisible="addressShow" @closed="addressShow=false" />
    <DialogDriver :dialogVisible="driverShow" @closed="driverShow=false" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OperationHistory from './DialogOperationHistory'
import DialogDate from './DialogDate'
import DialogAddress from './DialogAddress'
import DialogDriver from './DialogDriver'

export default {
  name: 'BtnEdit',
  components: {
    OperationHistory,
    DialogDate,
    DialogAddress,
    DialogDriver
  },
  props: {
    canModifyContent: {
      type: Boolean,
      // default: false
      required: true
    },
    canModifyDate: {
      type: Boolean,
      required: true
    },
    canModifyAddress: {
      type: Boolean,
      required: true
    },
    canModifyDriver: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      historyShow: false,
      dateShow: false,
      addressShow: false,
      driverShow: false,
      historyData: []
    }
  },
  methods: {
    ...mapActions({
      orderHistory: 'edit/orderHistory'
    }),
    handleCommand (command) {
      if (command === 'content') {
        this.handleEdit()
      } else if (command === 'history') {
        this.handleHistory()
      } else if (command === 'date') {
        this.handleDate()
      } else if (command === 'address') {
        this.handleAddress()
      } else if (command === 'driver') {
        this.handleDriver()
      }
    },
    handleEdit () {
      const routeName = this.$route.params.routeName
      const id = this.$route.params.id
      this.$router.push({ name: 'OrderEdit', params: { routeName, id } })
    },
    async handleHistory () {
      this.historyShow = true
      const id = this.$route.params.id
      const data = await this.orderHistory(id)

      this.historyData = data
    },
    handleDate () {
      this.dateShow = true
    },
    handleAddress () {
      this.addressShow = true
    },
    handleDriver () {
      this.driverShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: #3d86c7;
  border-color: #3d86c7;
  margin-left: 10px;
}
.btn:hover,
.btn:focus {
  background-color: #4d97d8;
  border-color: #4d97d8;
}
</style>
